import iconWhite from '../assets/ic-stats-white.svg';
import { IdelinkModuleTheme } from '../../../configs/IdeLinkTheme';

export const StatsTheme: IdelinkModuleTheme = {
    navbarIcon: iconWhite,
};
